// deps
import React, { memo } from "react";

// icons
import { default as CloseIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/clearDark/16";

// internal-deps
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import {
    CloseIconWrapper,
    HideOrderText,
    HideOrderTextWrapper,
    IncognitoSilentTextWrapper,
    SilentText,
    SilentTextWrapper,
    ToolTipContainer,
    ToolTipContentContainer,
    ToolTipPointer,
} from "./styles";

// constants
import { CONSTANTS } from "@cart-ui/components/incognito-mode-widget/constants";

// test-ids
import { INCOGNITO_CART_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { useEffectOnce } from "@swiggy-private/core-ui";

export interface IToolTipWidget {
    setShowToolTip: Function;
    onClickContextualBannerDismiss: () => void;
    isIncognitoCart?: boolean;
    onImpressionContextualBanner: (isEnabled: boolean) => void;
}

const ToolTipWidget: React.FC<IToolTipWidget> = ({
    setShowToolTip,
    onClickContextualBannerDismiss,
    isIncognitoCart,
    onImpressionContextualBanner,
}) => {
    const handleToolTipCloseClick = () => {
        setShowToolTip(false);
        onClickContextualBannerDismiss();
    };

    useEffectOnce(() => {
        onImpressionContextualBanner(isIncognitoCart || false);
    });
    return (
        <ToolTipContainer
            isIncognitoCart={isIncognitoCart}
            data-testid={INCOGNITO_CART_DATA_TEST_IDS.TOOL_TIP.CONTAINER}
        >
            <ToolTipContentContainer>
                <IncognitoSilentTextWrapper data-testid={INCOGNITO_CART_DATA_TEST_IDS.TOOL_TIP.TEXT}>
                    <SilentTextWrapper>
                        <SilentText variant="V2.body1.neutral.regular" color="background_Primary">
                            {CONSTANTS.TOOL_TIP.SILENT_TEXT}
                        </SilentText>
                    </SilentTextWrapper>
                    <div>
                        <Text variant="V2.body2.neutral.bold" color="text_inverse_Highest_Emphasis">
                            {CONSTANTS.TOOL_TIP.INCOGNITO_MODE_TEXT}
                        </Text>
                    </div>
                </IncognitoSilentTextWrapper>
                <HideOrderTextWrapper>
                    <HideOrderText variant="V2.body2.neutral.regular" color="text_inverse_High_Emphasis">
                        {CONSTANTS.TOOL_TIP.HIDE_ORDER_TEXT}
                    </HideOrderText>
                </HideOrderTextWrapper>
                <CloseIconWrapper
                    onClick={handleToolTipCloseClick}
                    data-testid={INCOGNITO_CART_DATA_TEST_IDS.TOOL_TIP.CLOSE_BUTTON}
                >
                    <GenericIcon Icon={CloseIcon} />
                </CloseIconWrapper>
                <ToolTipPointer />
            </ToolTipContentContainer>
        </ToolTipContainer>
    );
};

export default memo(ToolTipWidget);
